// src/pages/TempHome.jsx
import React, { useContext } from 'react';
import AppContext from '../contexts/AppContext';
import AdvLogAnalysis from '../components/analysis/AdvLogAnalysis';
import ContentLogAnalysis from '../components/analysis/ContentLogAnalysis';

const Analytics = () => {
  const { selectedRole } = useContext(AppContext);

  const selectedRoleType = selectedRole?.type

  return (
    <div className='w-[90%] max-w-7xl mx-auto'>
      {selectedRole && selectedRoleType === 'venue' && (
        <div>
          <div className="mt-4 w-full overflow-y-auto rounded-[28px] border border-[#e2e7f6] bg-white p-5 shadow-[0_18px_42px_rgba(15,23,42,0.05)]">
            <ContentLogAnalysis key={selectedRole.id}></ContentLogAnalysis>
          </div>
        </div>
      )}

      {selectedRole && selectedRoleType === 'adv' && (

        <div className="mt-4 w-full overflow-y-auto rounded-[28px] border border-[#e2e7f6] bg-white p-5 shadow-[0_18px_42px_rgba(15,23,42,0.05)]">
          <AdvLogAnalysis></AdvLogAnalysis>
        </div>
      )}


    </div>
  );
};

export default Analytics;
